
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Url } from '../model/users.model';
import { Task } from '../model/tasks.model';

@Injectable()
export class TaskService {
    @LocalStorage() url: Url;

  	private headers = new Headers({ 'Content-Type': 'application/json' });

    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }


    constructor(public http:HttpClient) {}

	getTasks(): Observable<Task[]> { 
		return this.http.get<Task[]>(this.url.rest + '/tms/getTasks', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getTaskCategories(): Observable<any[]> { 
        return this.http.get<any[]>(this.url.rest + '/tms/getTaskCategories', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }
    
    createTask(task:Task): Observable<Task> {	
        return this.http.post<Task>(this.url.rest + '/tms/createTask', task , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    updateTask(task:Task): Observable<Task> {
        return this.http.post<Task>(this.url.rest + '/tms/updateTask', task , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    deleteTask(id: number): Observable<any[]> {
        return this.http.delete<any[]>(this.url.rest + '/tms/deleteTask/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    getTaskStatuses(): Observable<any[]> { 
        return this.http.get<any[]>(this.url.rest + '/tms/getTaskStatuses', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    getTasksByIncidentId(incidentId:number): Observable<Task[]> { 
        return this.http.get<Task[]>(this.url.rest + '/tms/getTasksByIncidentId/' + incidentId, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    updateAllTaskCompletedByIncidentId(incidentId:number) {
        return this.http.post(this.url.rest + '/tms/updateAllTasksCompletedByIncidentId/' + incidentId , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    updateAllTaskCompletedByCarId(carId:number) {
        return this.http.post(this.url.rest + '/tms/updateAllTasksCompletedByCarId/' + carId , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    updateTaskCompleted(taskId: number) {
        return this.http.post(this.url.rest + '/tms/updateTaskCompleted/' + taskId , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    getTasksByRepairRequestId(repairrequestid:number): Observable<Task[]> { 
        return this.http.get<Task[]>(this.url.rest + '/tms/getTasksByRepairRequestId/' + repairrequestid, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )  
    }

    getTasksByCarId(car:number): Observable<Task[]> { 
        return this.http.get<Task[]>(this.url.rest + '/tms/getTasksByCarId/' + car, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )  
    }
    
    updateAllTaskCompletedByRepairRequestId(repairrequestid:number) {
        return this.http.post(this.url.rest + '/tms/updateAllTasksCompletedByRepairRequestId/' + repairrequestid , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )     
    }

    getTasksByDamageReportId(damagereportid:number): Observable<Task[]> { 
        return this.http.get<Task[]>(this.url.rest + '/tms/getTasksByDamageReportId/' + damagereportid, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )     
    }

    updateAllTaskCompletedByDamageReportId(damagereportid:number) {
        return this.http.post(this.url.rest + '/tms/updateAllTasksCompletedByDamageReportId/' + damagereportid , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )     
    }

    getTasksByTrafficTicketId(trafficticketid:number): Observable<Task[]> { 
        return this.http.get<Task[]>(this.url.rest + '/tms/getTasksByTrafficTicketId/' + trafficticketid, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )     }

    updateAllTaskCompletedByTrafficTicketId(trafficticketid:number) {
        return this.http.post(this.url.rest + '/tms/updateAllTasksCompletedByTrafficTicketId/' + trafficticketid , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }   	
       
    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }

   
}